import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm } from "soft_digi";
import { CUSTOMER_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { ALLOW_ALPHABET_SPACE } from "../../services/PatternSerivce";
import {
  admin_states_select,
  hubs_get_all_select,
} from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import CustomerSubForm from "./CustomerSubForm";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import Swal from "sweetalert2";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}

const schema = Yup.object().shape({
  vendor_company: Yup.string()
    .required("Company is required")
    .max(100, "Company name must be less than 100 characters"),

  vendor_name: Yup.string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s]*$/, "Only alphabets and spaces are allowed")
    .max(50, "Name must be less than 50 characters"),

  pan_no: Yup.string()
    .required("PAN No. is required")
    .length(10, "PAN No. must be exactly 10 characters")
    .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, "Invalid PAN format (e.g., ABCDE1234F)"),

  single_bill: Yup.object().shape({
    value: Yup.string().required("Is Single Item Billing is required"),
  }),

  /*
  // OLD VALIDATION — DO NOT REMOVE
  single_bill_hsn: Yup.string().when('single_bill.value', (value: any, schema) => {
    return value === "2"
      ? schema.required("HSN is required for single item billing")
             .max(10, "HSN must be less than 10 characters")
      : schema;
  }),

  single_bill_title: Yup.string().when('single_bill.value', (value: any, schema) => {
    return value === "2"
      ? schema.required("Description is required for single item billing")
             .max(100, "Description must be less than 100 characters")
      : schema;
  }),
  */

  sub_data: Yup.array().when("single_bill.value", (value: any, schema) => {
    return value === "1"
      ? schema
          .of(
            Yup.object().shape({
              hsn: Yup.string()
                .required("HSN is required")
                .max(10, "HSN must be less than 10 characters"),
              title: Yup.string()
                .required("Description is required")
                .max(100, "Description must be less than 100 characters"),
            })
          )
          .min(1, "At least one item is required")
      : schema;
  }),
});


const CustomersForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const { closeModal } = useSiteContext();


  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...dataIn,
      single_bill: dataIn?.single_bill
        ? {
            value: Number(dataIn.single_bill.value),
            label: dataIn.single_bill.label,
          }
        : null,

      single_new_bill: dataIn?.single_new_bill
        ? {
            value: Number(dataIn.single_new_bill.value),
            label: dataIn.single_new_bill.label,
          }
        : null,
    },
    resolver: yupResolver(schema),
  });

  const having_other = watch("single_bill");
  const having_other_new = watch("single_new_bill");


  const onSubmit = (data: any) => {
    let url = CUSTOMER_URLS.INSERT;

    if (data.ID !== undefined) {
      data["id"] = data.ID;
      url = CUSTOMER_URLS.UPDATE;
    }

    const subscription = post(url, data).subscribe(() => {
      loadTableData();
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
    });

    return () => subscription.unsubscribe();
  };

  const options = [
    { value: "2", label: "Yes" },
    { value: "1", label: "No" },
  ];

  const optionsNew = [
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];


  const formElements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 4,
      name: "vendor_company",
      element: {
        label: "Company",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "TEXT_BOX",
      width: 4,
      name: "vendor_name",
      element: {
        label: "Name",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "TEXT_BOX",
      width: 4,
      name: "pan_no",
      element: {
        label: "PAN No.",
        isRequired: true,
        inputType: "BORDER_LABEL",
        max: 10,
      },
    },

    {
      type: "SELECT_BOX",
      width: 12,
      name: "single_bill",
      element: {
        label: "Is Single Item Billing",
        isRequired: true,
        inputType: "BORDER_LABEL",
        options: options,
      },
    },

    {
      type: "SELECT_BOX",
      width: 12,
      name: "single_new_bill",
      element: {
        label: "Do you want change the descriptions of standard items?",
        isRequired: true,
        inputType: "BORDER_LABEL",
        options: optionsNew,
      },
      hideFunction: () =>
        !(having_other && Number(having_other.value) === 1),
    },

    {
      type: "TEXT_BOX",
      width: 4,
      name: "single_bill_hsn",
      element: {
        label: "HSN (Single Item)",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
      hideFunction: () =>
        !(having_other && Number(having_other.value) === 2),
    },

    {
      type: "TEXT_BOX",
      width: 8,
      name: "single_bill_title",
      element: {
        label: "Description (Single Item)",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
      hideFunction: () =>
        !(having_other && Number(having_other.value) === 2),
    },

    {
      type: "LABEL",
      width: 12,
      name: "test",
      labelComponent: (
        <CustomerSubForm
          errors={errors}
          control={control}
          watch={watch}
          setValue={setValue}
          dataIn={dataIn}
        />
      ),
      hideFunction: () =>
        !(having_other_new && Number(having_other_new.value) === 1),
    },

    {
      type: "LABEL",
      width: 9,
      name: "test_one",
    },

    {
      type: "BUTTON",
      width: 1,
      name: "close_button",
      element: {
        classList: ["button", "smart-third-button"],
        label: "Close",
        onClick: closeModal,
      },
    },

    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="sd-efl-input">
      <SdsForm elements={formElements} errors={errors} control={control} />
    </div>
  );
};

export default CustomersForm;
